import React, { useCallback, memo } from 'react';
import { Emoji } from 'react-apple-emojis';
import './FilterSection.scss';

const FILTERS = [
  { key: 'age',        label: 'AGE',        emoji: 'birthday-cake' },
  { key: 'pay',        label: 'PAY',        emoji: 'dollar-banknote' },
  { key: 'time',       label: 'TIME',       emoji: 'alarm-clock' },
  { key: 'volunteer',  label: 'FOCUS AREA',  emoji: 'brain' },
  { key: 'education',  label: 'ACADEMIC LEVEL',  emoji: 'school' },
];

function FilterSection({
  activeFilter,
  onFilterChange,
  onAgeClick,
  onPayClick,
  onTimeClick,
  onEducationClick,
  onFocusAreaClick,
  onFilterMenuClick,
}) {
	const handleFilterClick = useCallback(key => {
    if (key === 'age') {
      onAgeClick();
      return;
    }

    if (key === 'pay') {
      onPayClick();
      return;
    }

    if (key === 'time') {
      onTimeClick();
      return;
    }

    if (key === 'education') {
      onEducationClick();
      return;
    }

    if (key === 'volunteer') {
      onFocusAreaClick();
      return;
    }

    onFilterChange(key);
  }, [onAgeClick, onPayClick, onTimeClick, onEducationClick, onFocusAreaClick, onFilterChange]);

  const handleFilterIconClick = useCallback(() => {
    onFilterMenuClick();
  }, [onFilterMenuClick]);

  return (
    <div className="filters-section" role="group" aria-label="Filter opportunities">
      <div className="filter-row">
        <button
          className="filter-trigger-btn"
          onClick={handleFilterIconClick}
          aria-label="Open filter options"
          type="button"
        >
          <span className="filter-trigger-svg" aria-hidden="true">
            <span className="slider-line">
              <span className="slider-circle slider-circle-1"></span>
            </span>
            <span className="slider-line">
              <span className="slider-circle slider-circle-2"></span>
            </span>
          </span>
        </button>
        {FILTERS.map(f => (
          <button
            key={f.key}
            className={`filter-btn${activeFilter === f.key ? ' active' : ''}`}
            onClick={() => handleFilterClick(f.key)}
            type="button"
            aria-pressed={activeFilter === f.key}
          >
            <Emoji name={f.emoji} width={16} className="filter-icon" aria-hidden="true" />
            {f.label}
          </button>
        ))}
      </div>
    </div>
  );
}

export default memo(FilterSection);
